.filter {
	display: flex;
	align-items: center;
	gap: var(--size-2);
	flex-shrink: 0;
	padding: 0 var(--size-2);
	border: 2px solid var(--color-primary-background);
	border-radius: var(--radius-lg);
	font-size: var(--text-legal);
	color: var(--color-primary-foreground);
	background-color: var(--color-primary-background);
	font-weight: 500;
	letter-spacing: 0.025em;
	white-space: nowrap;

	.label {
		text-transform: uppercase;
		padding: var(--size-2);
	}
}

.clear {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: var(--size-2);
	border-radius: var(--radius-sm);
	color: var(--color-text-subtle);

	&:hover,
	&:focus-visible {
		background: var(--color-surface-hover);
		color: var(--color-text);
	}
}
